import IframeResizer from '@rio-cloud/iframe-resizer';

import { config } from '../../config';

const FreeTrialButton = () => {
    const url = config.marketplaceFreeTrialButtonUri;
    return <IframeResizer title='Marketplace free trial' src={url} height={0} />;
};

export default FreeTrialButton;
